import {
  STORY_DOWNLOAD_URL_V2,
  MOMENT_DOWNLOAD_URL,
  ANNOTATED_MOMENT_DOWNLOAD_URL,
  PRINT_ORDER_URL,
  MIMETYPES
} from 'shared/utils/Constants';

import JSZip from 'jszip';

import { get } from 'shared/services/ApiService';

export const downloadStory = (story, momentIds) => {
  let filename = 'download.zip';
  if (story.name) {
    filename = story.name.toLowerCase().replaceAll(/[^a-z0-9]/g, '-') + '.zip';
  }

  const url = STORY_DOWNLOAD_URL_V2(story.id, momentIds, filename);

  return downloadUrl(filename, url);
}

export const downloadUrl = (filename, url) => {
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();

  return Promise.resolve();
}

export const downloadMomentBlob = (moment, includeAccessCode = false) => {
  let downloadUrl = MOMENT_DOWNLOAD_URL;
  if (includeAccessCode) {
    downloadUrl = ANNOTATED_MOMENT_DOWNLOAD_URL;
  }

  get(downloadUrl(moment.id))
    .then(resp => resp.blob())
    .then(blob => {
      const type = Object.keys(MIMETYPES).includes(moment?.type) ? MIMETYPES[moment?.type] : 'jpg';
      const elem = window.document.createElement('a');
      elem.href = window.URL.createObjectURL(blob);
      elem.download = `${moment.id}.${type}`;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }
    )
}

export const downloadPrintOrder = (purchaseId) => {
  get(PRINT_ORDER_URL(purchaseId))
    .then(resp => resp.blob())
    .then(blob => {
      const elem = window.document.createElement('a');
      elem.href = window.URL.createObjectURL(blob);
      elem.download = `${purchaseId}-print_order.csv`;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }
    )
}

export const downloadMomentsToZip = async (moments) => {
  const zip = new JSZip();
  let downloadUrl = MOMENT_DOWNLOAD_URL;


  for (var moment of moments) {
    const response = await get(downloadUrl(moment.id));
    const blob = await response.blob();
    const type = Object.keys(MIMETYPES).includes(moment?.type) ? "." + MIMETYPES[moment?.type] : '.jpg';
    const filename = moment.id + type;
    zip.file(filename, blob);
  }

  const blob = await zip.generateAsync({ type: "blob" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "my-files.zip";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
